type Action = 'link_click' | 'sticky_cta_state_change'

type EventName =
  | 'main_cta_get_started'
  | 'secondary_cta_get_started_without_discount'
  | 'secondary_cta_get_started_with_discount'
  | 'tertiary_cta_get_started'
  | 'sticky_footer_cta_with_discount'
  | 'sticky_promobanner_state_change'

export type RafTrackingEventType = {
  action: Action
  properties: {
    component_name: EventName
    in_view?: string
  }
}

export const heroGetStartedTrackingEvent: RafTrackingEventType = {
  action: 'link_click',
  properties: {
    component_name: 'main_cta_get_started',
  },
}

export const priceComparisonGetStartedTrackingEvent: RafTrackingEventType = {
  action: 'link_click',
  properties: {
    component_name: 'secondary_cta_get_started_with_discount',
  },
}

export const peekInsideBoxGetStartedTrackingEvent: RafTrackingEventType = {
  action: 'link_click',
  properties: {
    component_name: 'tertiary_cta_get_started',
  },
}

export const valueForMoneyTrackingEvent: RafTrackingEventType = {
  action: 'link_click',
  properties: {
    component_name: 'secondary_cta_get_started_without_discount',
  },
}

export const FooterStickyGetStartedTrackingEvent: RafTrackingEventType = {
  action: 'link_click',
  properties: {
    component_name: 'sticky_footer_cta_with_discount',
  },
}

export const HeaderStickyPromoBannerTrackingEvent: RafTrackingEventType = {
  action: 'link_click',
  properties: {
    component_name: 'sticky_promobanner_state_change',
  },
}

export const StickyTrackingEvent = ({
  isVisible,
  name,
}: {
  isVisible: boolean
  name: EventName
}): RafTrackingEventType => ({
  action: 'sticky_cta_state_change',
  properties: {
    component_name: name,
    in_view: String(isVisible),
  },
})
